import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import { CardActionArea } from "@mui/material";
import { LocationCityRounded } from "@mui/icons-material";

function PlaceCard({ setPage, page, data }) {
  data = data ?? page.place;
  // if (data.Name === "CHATEAUROUX") {
  //   data.Name = "ChateauRoux en Brie sur Condé ";
  //   data.Street = "127 Grand Rue de la place au houblon";
  //   data.PostalCode = "67500";
  //   data.City = "Haguenau";
  // }

  const handleClick = (e) => {
    if (!page.valid) {
      page.page === 0
        ? setPage({
            ...page,
            page: 1,
            place: data,
          })
        : setPage({
            ...page,
            page: 0,
            place: null,
            motif: null,
            praticien: null,
            date: "",
            valid: false,
          });
    }
  };

  return (
    <Card
      style={{
        cursor: page.page !== 5 ? "pointer" : "default",
        // boxShadow: "5px 5px 15px 5px rgba(0,0,0,0.25)",
      }}
      sx={{ "&:hover": { boxShadow: 4 } }}
    >
      <CardActionArea
        onClick={(event) => handleClick()}
        style={{ width: "360px", height: "160px" }}
      >
        <CardContent>
          <Stack direction={"row"} alignItems="center">
            {/* Avatar de l'établissement */}
            {data.Photo ? (
              <Avatar
                alt={data.Name}
                src={"data:image/jpg;base64," + data.Photo}
                sx={{ width: 96, height: 96 }}
              />
            ) : (
              <Avatar alt={data.Name} sx={{ width: 96, height: 96 }}>
                <LocationCityRounded fontSize={"large"} />
              </Avatar>
            )}
            <Stack direction="column" spacing={0} ml={2}>
              {/* Nom de l'établissement */}
                          <Typography variant="h6" className="allow-newline-fix">{data.Name}</Typography>

              {/* Adresse de l'établissement */}
                          {data.Street ? (
                  <Stack>
                                  <Typography variant="h8" className="allow-newline-fix">
                  {/* <LocationOnOutlinedIcon
                    fontSize={"small"}
                    color={"primary"}
                    mt={5}
                  /> */}
                                      <div>{data.Street}</div>
                </Typography>
                                  <Typography variant="h8">{data.PostalCode} {data.City}</Typography>
                                  {data.PhoneNo ? (<Typography variant="h8">{data.PhoneNo}</Typography>): ( '' )}
                </Stack>
              ) : (
                <Typography variant="h8">Pas d'adresse renseignée</Typography>
              )}
            </Stack>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

export default PlaceCard;
